<template>
  <div class="child-bg-image">
    <div class="bg-image-section" />
    <div class="content-section">
      <active-check-ins />
    </div>
  </div>
</template>

  <script>
  import ActiveCheckIns from '../Components/ActiveCheckInPage.vue';

  export default {
    name: 'Organizations',
    components: {
      'active-check-ins': ActiveCheckIns,
    },
  };
  </script>

  <style scoped>

  </style>
